/**
 * 헤더 알림 드롭다운: 열릴 때 최근 알림을 fetch하여 목록 렌더링
 */

const SELECTOR = "[data-admin-notifications]";
const LIST_ATTR = "data-admin-notifications-list";
const URL_ATTR = "data-admin-notifications-url";

export function initAdminNotificationsDropdown(): void {
  const el = document.querySelector<HTMLDetailsElement>(SELECTOR);
  if (!el) return;

  const listEl = el.querySelector<HTMLElement>(`[${LIST_ATTR}]`);
  const url = el.getAttribute(URL_ATTR);
  if (!listEl || !url) return;

  let loaded = false;

  el.addEventListener("toggle", () => {
    if (!el.open || loaded) return;
    loaded = true;

    const loading = listEl.querySelector(".admin-header__notifications-loading");
    if (loading) loading.textContent = "불러오는 중…";

    fetch(url, {
      method: "GET",
      headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
    })
      .then((res) => res.json())
      .then((json: { success?: boolean; data?: { items?: Array<{ id: number; title: string; created_at_short: string }>; url?: string } }) => {
        const data = json?.data ?? json;
        const items = Array.isArray(data?.items) ? data.items : [];
        const allUrl = typeof data?.url === "string" ? data.url : "";

        if (loading) loading.remove();

        if (items.length === 0) {
          const p = document.createElement("p");
          p.className = "admin-header__notifications-loading admin-header__notifications-item--empty";
          p.textContent = "알림이 없습니다.";
          listEl.appendChild(p);
          return;
        }

        items.forEach((item) => {
          const a = document.createElement("a");
          a.href = allUrl;
          a.className = "admin-header__notifications-item";
          a.textContent = [item.title || "", " · ", item.created_at_short || ""].join("");
          listEl.appendChild(a);
        });
      })
      .catch(() => {
        if (loading) {
          loading.textContent = "불러오기에 실패했습니다.";
        }
      });
  });
}
